import module from 'colaborador/module'
import template from './template.html'

export class ColaboradorCajaAhorroFormularioComponent {
  idProyecto
  idColaborador
  onChange
  data

  constructor (ColaboradorCajaAhorros, ColaboradorCajaAhorro) {
    this.ColaboradorCajaAhorro = ColaboradorCajaAhorro
    this.ColaboradorCajaAhorros = ColaboradorCajaAhorros
  }

  $onInit () {
    this.promise = this.ColaboradorCajaAhorros.get(this.idProyecto, this.idColaborador)
    .then(({data}) => (this.cajaAhorro = data))
  }

  cerrar () {
    this.onChange()
  }

  finalizar () {
    this.onChange({$event: {data: this.data}})
  }

  obtenerCaja () {
    this.ColaboradorCajaAhorro.get(this.idProyecto, this.data.cajaAhorroId)
    .then(({data}) => (this.data = Object.assign(this.data, data)))
    .then(({data}) => (this.data.fechaInicialCaja = this.data.fechaInicial))
  }
}

module.component('colaboradorCajaAhorroFormulario', {
  controller: ColaboradorCajaAhorroFormularioComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/aportaciones/formulario/component.js